import { useState } from 'react'

import { If, ButtonContinue } from '@itau-loans-www/components'
import { finishProposalCallback } from '@itau-loans-www/hooks'
import classnames from 'classnames'

import Hero from '../Hero'
import './banner.scss'

const Banner = ({
  leadName = '',
  offerlessChannel = false,
  isMarginComplementary = false,
  hasHero,
  proposal,
  partner
}) => {
  const [loading, setLoading] = useState(false)
  const firstName = leadName.split(' ')[0]
  const bannerClasses = classnames(
    'banner-offer',
    {
      'banner-offer--offerless': offerlessChannel
    },
    { 'banner-offer__partner': partner },
    { 'banner-offer--marginComplementary': isMarginComplementary }
  )

  const titleClasses = classnames('banner-offer__title', {
    'banner-offer__title--offerless': offerlessChannel,
    'banner-offer__title--marginComplementary': isMarginComplementary
  })

  return (
    <section className={bannerClasses} data-cy="cy-banner-offer">
      <If
        condition={isMarginComplementary}
        renderIf={
          <>
            <h1 className={titleClasses}>
              Você não possui ofertas no momento, quer garantir uma oportunidade
              para 2024?
            </h1>
            <div className="banner-offer__cta--marginComplementary">
              <div className="banner-offer__cta-wrapper--marginComplementary">
                <p className="banner-offer__subtitle--marginComplementary">
                  Aproveite o aumento do salário mínimo no início do ano que vem
                  e e aproveite uma oportunidade de renda extra!
                </p>
                <p className="banner-offer__subtitle--marginComplementary">
                  Nossos especialistas entrarão em contato para finalizar sua
                  proposta
                </p>
                <ButtonContinue
                  currentProposal={proposal}
                  setButtonLoading={setLoading}
                  isButtonLoading={loading}
                  callback={finishProposalCallback}
                  id="hero-offer-consig-comp-marg-btn"
                  ariaLabel="tenho interesse"
                  buttonText="Tenho interesse"
                />
              </div>
            </div>
          </>
        }
        renderElse={
          <>
            <h1 className={titleClasses}>
              {firstName},{' '}
              {offerlessChannel
                ? 'infelizmente não temos ofertas de consignado para você...'
                : 'separamos a melhor oferta para você.'}
            </h1>
            <If condition={hasHero} renderIf={<Hero proposal={proposal} />} />
          </>
        }
      />
    </section>
  )
}

export default Banner
